import { isBreakoutCable } from '@/utils/is-breakout-cable'

function needsSpreaderFor ({ plugType }) {
  switch(plugType) {
    case 'URM NG P8':
      return false
    default:
      return true
  }
}

export function needsSpreader({cableType, plugType = 'sx'}) {
  return !isBreakoutCable({ cableType }) || needsSpreaderFor({ plugType })
}

export function needsShrinkingTube({ cableType, plugType = 'sx' }) {
  return isBreakoutCable({ cableType }) && !needsSpreaderFor({ plugType })
}